import { ColumnMappingCSV } from "../../../util/readCSV";
import { CartonTemplateCSV } from "./util";

export type CartonCsvDestinationFlags = {
  isToBrPort?: boolean;
  showOriginCriterion?: boolean;
};

export type CartonCsvValidationFlags = {
  shouldCheckUnitOfMeasure: boolean;
  showOriginCriterion: boolean;
};

export type CartonCsvTemplateLinks = {
  defaultTemplate: string;
  brazilTemplate?: string;
  originCriterionTemplate?: string;
};

/**
 * Maps destination UI flags to validateCSVFields argument order.
 * Order must stay: shouldCheckUnitOfMeasure, then showOriginCriterion.
 */
export const getCartonCsvValidationFlags = ({
  isToBrPort = false,
  showOriginCriterion = false,
}: CartonCsvDestinationFlags): CartonCsvValidationFlags => ({
  shouldCheckUnitOfMeasure: !!isToBrPort,
  showOriginCriterion: !!showOriginCriterion,
});

export const filterCartonCsvHeaderMapping = <T extends CartonTemplateCSV>(
  mapping: ColumnMappingCSV<T>,
  { isToBrPort = false, showOriginCriterion = false }: CartonCsvDestinationFlags
): ColumnMappingCSV<T> => {
  const nextMapping = { ...mapping };

  if (!isToBrPort) {
    const unitOfMeasureHeader = Object.keys(nextMapping).find(
      (key) => nextMapping[key] === "unitOfMeasure"
    );
    if (unitOfMeasureHeader) delete nextMapping[unitOfMeasureHeader];
  }

  if (!showOriginCriterion) {
    const originCriterionHeader = Object.keys(nextMapping).find(
      (key) => nextMapping[key] === "originCriterion"
    );
    if (originCriterionHeader) delete nextMapping[originCriterionHeader];
  }

  return nextMapping;
};

export const getCartonCsvTemplateUrl = (
  { isToBrPort = false, showOriginCriterion = false }: CartonCsvDestinationFlags,
  links: CartonCsvTemplateLinks
): string => {
  return links.defaultTemplate;
};
